import script from "./CreateUnitDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUnitDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateUnitDialog.vue?vue&type=style&index=0&id=3bf836ea&lang=css"

const __exports__ = script;

export default __exports__